export default __webpack_public_path__ + "static/media/disk.d88986c7.png";